<template>
  <!-- begin:: Page -->
  <div class="container">
    <div class="row">
      <div class="bg-1">
        <div class="bg-form bg-white shadow">
          <button
            type="button"
            class="auth-theme-toggle"
            :aria-label="currentTheme === 'dark' ? 'فعال کردن حالت روشن' : 'فعال کردن حالت تاریک'"
            :aria-pressed="currentTheme === 'dark'"
            @click="toggleTheme"
          >
            <svg v-if="currentTheme === 'dark'" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="4" /><path d="M12 2.5v2" /><path d="M12 19.5v2" /><path d="M2.5 12h2" /><path d="M19.5 12h2" /><path d="M5 5l1.4 1.4" /><path d="M17.6 17.6L19 19" /><path d="M19 5l-1.4 1.4" /><path d="M6.4 17.6L5 19" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11.01 3.05C6.51 3.54 3 7.36 3 12c0 4.97 4.03 9 9 9c4.63 0 8.45-3.5 8.95-8c.09-.79-.78-1.42-1.54-.95c-.84.54-1.84.85-2.91.85c-2.98 0-5.4-2.42-5.4-5.4c0-1.06.31-2.06.84-2.89c.45-.62-.04-1.56-.93-1.56z" />
            </svg>
          </button>
          <div class="login-header">
            <span class="login-logo-chip">
              <img :src="currentLogo" alt="Paystar Logo">
            </span>
          </div>
          <slot></slot>
        </div>
      </div>
      <div class="bg-2">
        <div class="bg-img shadow"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  data() {
    return {
      currentTheme: 'dark'
    }
  },
  computed: {
    currentLogo() {
      return require('@/assets/new/image/logo_new_dark.png');
    }
  },
  methods: {
    updateTheme() {
      this.currentTheme = window.localStorage.getItem('AppUiTheme') || 'dark';
    },
    toggleTheme() {
      this.setTheme(this.currentTheme === 'dark' ? 'light' : 'dark');
    },
    setTheme(theme) {
      theme = String(theme);
      window.localStorage.setItem('AppUiTheme', theme);
      this.currentTheme = theme;

      switch (theme) {
        case 'light':
          this.unloadDarkThemeCss();
          break;
        case 'dark':
          this.loadDarkThemeCss();
          break;
        default:
          this.setTheme('light');
          break;
      }

      window.dispatchEvent(new Event('themeChanged'));
    },
    loadDarkThemeCss() {
      if (document.getElementById('dark_theme_style_file')) return;
      let file = document.createElement('link');
      file.rel = 'stylesheet';
      file.id = 'dark_theme_style_file';
      file.href = '/assets/new/style/dark-theme.css';
      let parent = document.getElementById('dark_theme_style_container');
      if (parent) parent.appendChild(file);
    },
    unloadDarkThemeCss() {
      let element = document.getElementById('dark_theme_style_file');
      let parent = document.getElementById('dark_theme_style_container');

      if (element && parent) {
        parent.removeChild(element);
      }
    }
  },
  mounted() {
    this.updateTheme();
  }
}
</script>

<style scoped>
.container {
  max-width: 1700px;
  background-size: cover;
  margin: auto;
}
.bg-form {
  position: relative;
}
.login-logo-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 22px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
}
.login-header > .login-logo-chip > img {
  width: 170px;
  display: block;
}
.auth-theme-toggle {
  position: absolute;
  top: 14px;
  left: 14px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(128, 128, 128, 0.35);
  background: transparent;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease;
  z-index: 2;
}
.auth-theme-toggle:hover {
  color: #00bea5;
  border-color: #00bea5;
}
.auth-theme-toggle:focus-visible {
  outline: 2px solid #00bea5;
  outline-offset: 2px;
}
</style>
